/**
 * Created by junwon on 2017. 3. 4..
 */
import {Component} from "@angular/core";


// EnHeaderComponent
@Component({
  selector: 'header.en',
  templateUrl: 'header.html',
})
export class EnHeaderComponent {
}

@Component({
  selector: 'footer.en',
  templateUrl: 'footer.html',
})
export class EnFooterComponent {
}

// EnHomeComponent
@Component({
  templateUrl: 'home.html',
})
export class EnHomeComponent {
}

// EnIntroComponent
@Component({
  templateUrl: 'intro.html',
})
export class EnIntroComponent {
}

// EnSpeakersComponent
@Component({
  templateUrl: 'speakers.html',
})
export class EnSpeakersComponent {
}



// WEBPACK FOOTER //
// ./src/app/en/en.component.ts